import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { CacheInterceptorEffect } from './cache-interceptor.effect';

@NgModule({
  imports: [EffectsModule.forFeature([CacheInterceptorEffect])],
})
export class CacheInterceptorModule {}
